<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基本信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="试卷分类名称">{{form.name}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{form.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{form.state?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">题目信息</span></div>
      <el-descriptions :column="1">
        <el-descriptions-item label="题目">{{form.title}}</el-descriptions-item>
        <el-descriptions-item v-for="(item,index) in form.courseTopicAnswerList" :key="index" :label="'选项'+item.code">{{item.content}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">答案与解析</span></div>
      <el-descriptions :column="1">
        <el-descriptions-item label="正确答案">{{form.correctAnswer}}</el-descriptions-item>
        <el-descriptions-item label="题目解析">{{form.resolutionContent}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import courseTopicApi from '@/api/course/courseTopic'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    handleShow() {
      courseTopicApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
        this.form.createdTime = this.rowItem.createdTime
        this.form.correctAnswer = this.rowItem.correctAnswer
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
</style>
